var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"pb-2",attrs:{"lg":"12"}},[_c('b-button',{attrs:{"size":"lg"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("登出")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }